export default __webpack_public_path__ + "static/media/FlyingFrog31.2710f9f4.png";